import { useAuth0 } from "@auth0/auth0-react";
import dynamic from "next/dynamic";
import type { FC } from "react";

import { type DocumentMetadata } from "@moment/api-collab/api-types";
import { ChevronRightIcon } from "@moment/icons";
import { useEnv } from "@moment/state";
import { LinkButton, ThemeSwitcher } from "@moment/ui";

const Profile = dynamic(async () => (await import("~/components/topbar/Profile")).Profile, {
	ssr: false,
});

const LoginButton = dynamic(
	async () => (await import("~/components/topbar/LoginButton")).LoginButton,
	{
		ssr: false,
	}
);

export const PublishHeaderActions: FC<{
	documentMetadata: DocumentMetadata;
	className?: string;
}> = ({ documentMetadata, className }) => {
	const { isAuthenticated } = useAuth0();
	const { isWebApp } = useEnv();

	return (
		<div className={className}>
			{documentMetadata.publishSettings?.topbarLinks
				?.filter((link) => link != null)
				.map(({ name, url }) => (
					<LinkButton
						key={`${name}-${url}`}
						preset="quaternary"
						href={url}
						target="_blank"
					>
						{name}
					</LinkButton>
				))}
			{documentMetadata.publishSettings?.topbarCtaButton && (
				<LinkButton
					preset="primary"
					href={documentMetadata.publishSettings?.topbarCtaButton.url ?? "#"}
					target="_blank"
					borderRadius="full"
					endIcon={<ChevronRightIcon />}
				>
					{documentMetadata.publishSettings.topbarCtaButton.name}
				</LinkButton>
			)}

			{!isWebApp && (isAuthenticated ? <Profile /> : <LoginButton />)}
			<ThemeSwitcher />
		</div>
	);
};
